import { render, staticRenderFns } from "./RetailerTeammatesModal.vue?vue&type=template&id=270dbcdc&"
import script from "./RetailerTeammatesModal.vue?vue&type=script&lang=js&"
export * from "./RetailerTeammatesModal.vue?vue&type=script&lang=js&"
import style0 from "./RetailerTeammatesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports